// ========================================
// HOOK useMessages
// Gestion des messages de contact
// ========================================

import { useState, useEffect, useCallback } from 'react';
import { getMessages, markAsRead, deleteMessage, sendMessage } from '../services/firebase/messagesService';
import { toast } from 'react-toastify';

const useMessages = (autoFetch = true) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchMessages = useCallback(async () => {
    setLoading(true);
    setError(null);

    const result = await getMessages();

    if (result.success) {
      setMessages(result.data);
    } else {
      setError(result.error);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    if (autoFetch) {
      fetchMessages();
    }
  }, [autoFetch, fetchMessages]);

  const markMessageAsRead = async (messageId) => {
    const result = await markAsRead(messageId);

    if (result.success) {
      setMessages(prev =>
        prev.map(msg =>
          msg.id === messageId ? { ...msg, isRead: true } : msg
        )
      );
    }

    return result;
  };

  const removeMessage = async (messageId) => {
    const result = await deleteMessage(messageId);

    if (result.success) {
      toast.success('Message supprimé');
      setMessages(prev => prev.filter(msg => msg.id !== messageId));
    } else {
      toast.error('Erreur lors de la suppression');
    }

    return result;
  };

  const send = async (messageData) => {
    const result = await sendMessage(messageData);

    if (result.success) {
      toast.success('Message envoyé !');
    } else {
      toast.error('Erreur lors de l\'envoi');
    }

    return result;
  };

  const unreadCount = messages.filter(msg => !msg.isRead).length;

  return {
    messages,
    loading,
    error,
    unreadCount,
    fetchMessages,
    markMessageAsRead,
    removeMessage,
    sendMessage: send
  };
};

export default useMessages;